import * as identityStore from '../identity';
import * as coreStore from '../store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';
import { Role } from '@core/authentication/auth.roles';
import { select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard {
  constructor(private store: Store, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.pipe(
      select(identityStore.selectIdentityAccount(coreStore.selectIdentityState)),
      map(account => {
        const userRoles = account?.idTokenClaims?.roles;

        if (!userRoles) {
          return false;
        }

        const allowedRoles = next.data.roles;
        const matchingRoles = userRoles.filter(x => allowedRoles.includes(x));

        if (matchingRoles.length > 0) {
          return true;
        } else {
          this.router.navigate([this.routeByRole(userRoles)]);
          return false;
        }
      })
    );
  }

  routeByRole(roles: string[]): string {
    if (roles.includes(Role.Standard)) {
      return '/overview';
    } else if (
      roles.includes(Role.Locations_Dfmg) ||
      roles.includes(Role.Locations_T_Systems) ||
      roles.includes(Role.Locations_Whitelist)
    ) {
      return '/consumption-points';
    } else if (roles.includes(Role.Reporting)) {
      return '/reports';
    } else if (roles.includes(Role.Settings)) {
      return '/settings';
    } else {
      return '/sessions/403';
    }
  }

  canActivateChild(
    next: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(next);
  }
}
